module.exports = __webpack_public_path__ + "static/media/bird4.267f2fa6.jpg";